class assignClothReq {
  // debugger;
  WorkStepTypeID: string;
  ResponsibleFirstPartyID: string;
  ResponsibleSecondPartyID: string;
  OtherInformation: string;
  DateTime: any;
  OraderDetailID_GUID_List: Array;
  innerObj: any;

  assignClothReq() {
    // debugger;
    this.WorkStepTypeID = "";
    this.ResponsibleFirstPartyID = "";
    this.ResponsibleSecondPartyID = "";
    this.OtherInformation = "";
    this.DateTime = new Date();
    this.OraderDetailID_GUID_List = [];
  }
}

export default assignClothReq;
